import { render, staticRenderFns } from "./TopicApiStudy.vue?vue&type=template&id=caeaa1ae&scoped=true&"
import script from "./TopicApiStudy.vue?vue&type=script&lang=js&"
export * from "./TopicApiStudy.vue?vue&type=script&lang=js&"
import style0 from "./TopicApiStudy.vue?vue&type=style&index=0&id=caeaa1ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caeaa1ae",
  null
  
)

export default component.exports